const BASE_URL: string = "https://officalyourhope-001-site5.ktempurl.com/api/";

// const BASE_URL: string = "http://localhost:5210/api/";

export default BASE_URL;
